import { render, staticRenderFns } from "./GovApprovedId.vue?vue&type=template&id=9a7f4edc&"
import script from "./GovApprovedId.vue?vue&type=script&lang=js&"
export * from "./GovApprovedId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports